module.exports = __webpack_public_path__ + "static/media/aly_v1.8c49bd44.png";